import React from 'react';
import { LoanDrawPanel } from '../../components/LoanDrawPanel/LoanDrawPanel';
import { IDashboardDrawBudget } from '@apply/api/src/api/DrawApi';
import { useAuthenticationStore } from '../../../../state/authenticationStore';

interface IDashboardParameters {
    dashboardDrawBudgets: IDashboardDrawBudget[] | undefined;
    loading: boolean;
}

export const Dashboard: React.FC<IDashboardParameters> = ({ dashboardDrawBudgets, loading }) => {
    const selectedAuthorizedDrawUserEntity = useAuthenticationStore((s) => s.selectedEntity);
    return (
        <div className='content'>
            <div className='contentSection full'>
                <h1>{selectedAuthorizedDrawUserEntity?.name}</h1>
                <LoanDrawPanel
                    dashboardDrawBudgets={dashboardDrawBudgets}
                    loading={loading}
                />
            </div>
        </div>
    );
};
